import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './DaasPanoPage.css';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import daaspano_bg from '../../images/DaasPano/daaspano_bg.png';
import yeongwol_pano from '../../images/DaasPano/yeongwol_pano.png';
import stadium_pano from '../../images/DaasPano/stadium_pano.png';
import park_pano from '../../images/DaasPano/park_pano.png';
import smlogo from '../../images/logo/4smapper_logo.png'; // ✅ 로고 추가

const DaasPano = () => {
  const { t } = useTranslation('daaspano');
  const [isLoaded, setIsLoaded] = useState(false);

  // ✅ 모든 이미지 로딩 완료 후 렌더링
  useEffect(() => {
    const images = [daaspano_bg, yeongwol_pano, stadium_pano, park_pano];
    let loaded = 0;

    images.forEach((src) => {
      const img = new Image();
      img.src = src;
      img.onload = () => {
        loaded++;
        if (loaded === images.length) setIsLoaded(true);
      };
    });
  }, []);

  return (
    <>
      <Header />
      <div className="Header_Block"></div>

      {!isLoaded ? (
        <div className="DaasPano_Loading_Screen">
          <img src={smlogo} alt="4S Mapper logo" className="DaasPano_Loading_Logo" />
        </div>
      ) : (
        <div className="DaasPanoContainer">
          <div className="DaasPanoSetion1">
            <img className="daaspano_bg" src={daaspano_bg} alt="Daas Pano Background" />
            <h1 className="daaspano_title">{t('title')}</h1>
            <div className="daaspano_des">{t('des')}</div>
          </div>

          <div className="DaasPanoSetion2">
            <div className="DaasPanoSetion2_Box_1">
              <div className="DaasPano_Img_box">
                <div
                  className="Img_Title"
                  onClick={() => window.open('http://yeongwol.dromii.com/', '_blank')}
                >
                  YEONGWOL
                </div>
                <img className="pano_bg" src={yeongwol_pano} alt="Yeongwol pano" />
              </div>
            </div>

            <div className="DaasPanoSetion2_Box_2">
              <div className="DaasPano_Img_box">
                <div
                  className="Img_Title"
                  onClick={() => window.open('http://worldcup.4smapper.com/', '_blank')}
                >
                  STADIUM
                </div>
                <img className="pano_bg" src={stadium_pano} alt="Stadium pano" />
              </div>

              <div className="DaasPano_Img_box">
                <div
                  className="Img_Title"
                  onClick={() => window.open('http://worldcuppark.4smapper.com/', '_blank')}
                >
                  PARK
                </div>
                <img className="pano_bg" src={park_pano} alt="Park pano" />
              </div>
            </div>
          </div>
        </div>
      )}

      {isLoaded && <Footer />}
    </>
  );
};

export default DaasPano;
